import { Injectable } from '@angular/core';

import { CusHttp } from '../../core/services/CusHttp';

// 获取三级省市区    api.shixi.com:81/v1/region/list
const CITYlISTURL = 'v1/region/list';

@Injectable()
export class LevelLinkageService {

  public cityList: any;

  constructor(
    public _http: CusHttp,
  ) { }

  getList() {
    if (!this.cityList) {
      return this._http.get(CITYlISTURL).then((data) => { 
        this.cityList = data; 
        return this.cityList;
      });
    } else {
      return Promise.resolve(this.cityList);
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/level-linkage/level-linkage.service.ts